'use es6';

import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
import LayoutSectionDropZoneContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionDropZoneContainer';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDndAreaElement } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { getLayoutSectionIsEmpty } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { makeGetLayoutSectionEmptyCells, makeGetLayoutSectionEmptyRows } from 'ContentEditorUI/redux/selectors/layoutDataSelectors';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { getCurrentDropTarget, getDragItemIsHidden } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import LayoutSectionEmptyCellPlaceholder from 'InpageEditorUI/components/LayoutSectionEmptyCellPlaceholder';
import LayoutSectionEmptyRowPlaceholder from 'InpageEditorUI/components/LayoutSectionEmptyRowPlaceholder';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = () => {
  const getLayoutSectionEmptyCells = makeGetLayoutSectionEmptyCells();
  const getLayoutSectionEmptyRows = makeGetLayoutSectionEmptyRows();
  return (state, props) => {
    const {
      layoutSectionId
    } = props;
    return {
      dragItemIsHidden: getDragItemIsHidden(state),
      dropTarget: getCurrentDropTarget(state),
      emptyCells: getLayoutSectionEmptyCells(state, {
        layoutSectionId
      }),
      emptyRows: getLayoutSectionEmptyRows(state, {
        layoutSectionId
      }),
      isEmpty: getLayoutSectionIsEmpty(state, layoutSectionId)
    };
  };
};
class LayoutSectionEmptyPlaceholderContainer extends Component {
  renderEmptyCellPlaceholders() {
    const {
      emptyCells,
      dragItemIsHidden,
      layoutSectionId,
      dropTarget
    } = this.props;
    return emptyCells.map(emptyCell => {
      const isHovered = !!dropTarget && !dragItemIsHidden && getImmutableOrPlain(dropTarget, 'id') === emptyCell.getName();
      return /*#__PURE__*/_jsx(LayoutSectionEmptyCellPlaceholder, {
        cellId: emptyCell.getName(),
        layoutSectionId: layoutSectionId,
        isHovered: isHovered
      }, emptyCell.getName());
    });
  }
  renderEmptyRowPlaceholders() {
    const {
      emptyRows,
      dragItemIsHidden,
      dropTarget
    } = this.props;
    return emptyRows.map(emptyRow => {
      const isHovered = !!dropTarget && !dragItemIsHidden && getImmutableOrPlain(dropTarget, 'id') === emptyRow.getName();
      return /*#__PURE__*/_jsx(LayoutSectionEmptyRowPlaceholder, {
        row: emptyRow,
        isHovered: isHovered
      }, emptyRow.getName());
    });
  }
  render() {
    const {
      dispatchActionToEventBus,
      isEmpty,
      layoutSectionId
    } = this.props;
    const layoutSectionElement = getDndAreaElement(layoutSectionId);
    return /*#__PURE__*/_jsxs("div", {
      children: [isEmpty ? /*#__PURE__*/_jsx(AfterBeginPortal, {
        id: `${EMPTY_PLACEHOLDER_ID_PARTIAL}-${layoutSectionId}`,
        targetElement: layoutSectionElement,
        children: /*#__PURE__*/_jsx(LayoutSectionDropZoneContainer, {
          dispatchActionToEventBus: dispatchActionToEventBus,
          parentId: layoutSectionId
        })
      }) : null, this.renderEmptyCellPlaceholders(), this.renderEmptyRowPlaceholders()]
    });
  }
}
LayoutSectionEmptyPlaceholderContainer.propTypes = {
  dispatchActionToEventBus: PropTypes.func.isRequired,
  dragItemIsHidden: PropTypes.bool.isRequired,
  dropTarget: PropTypes.object,
  emptyCells: PropTypes.array.isRequired,
  emptyRows: PropTypes.array.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  layoutSectionId: PropTypes.string.isRequired
};
export default connect(mapStateToProps)(LayoutSectionEmptyPlaceholderContainer);